// src/pages/ApplicationChampionshipStageStandings/utils/calculateStandingDerived.ts
//
// Cálculos derivados das colunas editáveis (J, SG, win_rate).
// O backend persiste esses 3 valores como input — quem calcula é o front.

export function calcPlayed(wins: number, draws: number, losses: number): number {
  return Math.max(0, (Number(wins) || 0) + (Number(draws) || 0) + (Number(losses) || 0));
}

export function calcGoalDiff(goalsFor: number, goalsAgainst: number): number {
  return (Number(goalsFor) || 0) - (Number(goalsAgainst) || 0);
}

/**
 * Aproveitamento em % (0–100), 2 casas decimais.
 * `points / (played * 3) * 100`. Retorna null se `played === 0`.
 */
export function calcWinRate(points: number, played: number): number | null {
  const p = Number(points) || 0;
  const j = Number(played) || 0;
  if (j <= 0) return null;
  const raw = (p / (j * 3)) * 100;
  return Math.round(raw * 100) / 100;
}
